import { Component, ViewEncapsulation, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
// import {ToastrConfig} from 'ngx-toastr';
import { Router, NavigationStart } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CustomHttp } from '../common/customHttp.service';
import { ApiUrl } from '../common/apiUrls';
import { ToastrService } from 'ngx-toastr';
import { AmplifyService } from '../common/amplify-service';
import { MatSidenav } from '@angular/material/sidenav';
import { ROUTE_TO_MENU_MAPPING } from '../common/routeMenuMapping';

@Component({
  selector: 'app-layout',
  providers: [],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  //  styleUrls: ['./initialstyle.scss']
  encapsulation: ViewEncapsulation.None,
})
//initialstyle
export class MainAppComponent implements OnInit, OnDestroy {
  @ViewChild('sidenav') sidenav: MatSidenav;
  
  // invert = false;
  public isAuthorize: boolean = false;
  public isLoggedIn: boolean = false;
  currentYear: number = new Date().getFullYear();
  logoutForm: FormGroup;
  selectedUser: string;
  token: string;
  isAdmin: boolean = false;
  public isDashboard: boolean = false;
  public baseClientId: string = "";
  public baseUserId: string = "";
  public selectedAccount: string = "";
  public isMenuClicked: boolean = false;
  public WelcomeName: string = "";
  milliSecond: string;
  public userId: string = "";
  public role: string = "";
  sideNavMode: string = "side";
  sideNavOpen = true;
  isResponsive: boolean = false;
  isMobile: boolean = false;
  menuItems: any[];
  photo: any;
  openMenuIndices: Set<number> = new Set();
  canAdd: boolean = false;
  canView: boolean = false;
  canEdit: boolean = false;
  canDelete: boolean = false;
  canRevert: boolean = false;
  isActive: boolean = false;
  isShowLoader: boolean = false;
  currentUserLabIds: any;
  currentUserDefaultCompanyId: any = 0;
  roleId: any;
  userTypeId: any;
  pageSize: number = 10;
  userName: string = "";

  currentRoute: string = '';
  private resizeTimer: any;
  
  // Sidebar collapse/expand state
  sidebarExpanded: boolean = false;
  hoveredMenuIndex: number = -1;
  private flyoutHoverTimer: any;
  private flyoutLeaveTimer: any;
  private flyoutPosition: { top: string; left: string } = { top: '50px', left: '70px' };

  constructor(public _router: Router, private _http: CustomHttp,
    private _appUrl: ApiUrl, private formBuilder: FormBuilder, private _toastrService: ToastrService,
    private _amplifySrvc: AmplifyService, private cdr: ChangeDetectorRef) {

    this.selectedAccount = "";

    // Track route changes for proper menu highlighting
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.currentRoute = event.url;
        var navUrl = event.url;
        if (navUrl.substring(0, 1) == '/') {
          navUrl = navUrl.substring(1);
        }
        var navurlArr = navUrl.split('/');
        if (navurlArr.length >= 1) {
          var currentPath = this._router.config.filter(config => config.path === navurlArr[0]);
          if (currentPath.length > 0 && currentPath[0].path != "" && currentPath[0].path.toLowerCase() !== 'login')
            this.GetPagePrivlages(currentPath[0].data.pagePriv);
        }
      }
    });
  }

  ngOnInit() {
    this.verifyUserAuthentication();
    this.detectScreenSize();
    window.addEventListener('resize', () => this.onWindowResize());
  }

  ngOnDestroy() {
    window.removeEventListener('resize', () => this.onWindowResize());
  }

  onWindowResize() {
    // Debounce the resize event to avoid multiple rapid calls
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
    
    this.resizeTimer = setTimeout(() => {
      this.detectScreenSize();
    }, 250);
  }

  detectScreenSize() {
    const screenWidth = window.innerWidth;
    
    // Determine if mobile (less than 768px)
    if (screenWidth < 768) {
      this.isMobile = true;
      this.sideNavMode = 'over';
      this.sideNavOpen = false;
    } else {
      this.isMobile = false;
      this.sideNavMode = 'side';
      this.sideNavOpen = true;
    }
  }

  verifyUserAuthentication() {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser != null && currentUser != "" && currentUser != undefined) {
      var curDate = new Date();
      var tokenExpiryDate = new Date(currentUser.ExpiryDate);
      if (curDate.getTime() < tokenExpiryDate.getTime()) {
        let curUserDetails = this.getCurrentUserData(currentUser.token);
        if (curUserDetails.LabIds)
          this.currentUserLabIds = JSON.parse(curUserDetails.LabIds);
        if (curUserDetails.DefaultCompanyId)
          this.currentUserDefaultCompanyId = curUserDetails.DefaultCompanyId;
        if (curUserDetails.RoleId)
          this.roleId = curUserDetails.RoleId;
        if (curUserDetails.UserTypeId)
          this.userTypeId = curUserDetails.UserTypeId;
        this.isAuthorize = true;
        this.GetMenuItems();
        this.GetUserProfile();

      }
      else {
        this.isAuthorize = false;
        this._amplifySrvc.ClearAll();
        this._router.navigate(['/login']);
      }

      if (localStorage.getItem('MenuItem')) {
        var currentUser = JSON.parse(localStorage.getItem('MenuItem'));
        this.role = currentUser.RoleName;
      }
      if (localStorage.getItem('UserName')) {
        this.isLoggedIn = true;
        var userDetails = JSON.parse(localStorage.getItem('UserName'));
        this.WelcomeName = userDetails.username;
      }
    }
    else {
      this._router.navigate(['/login']);
    }
  }



  ShowLoader() {
    this.isShowLoader = true;
  }

  HideLoader() {
    this.isShowLoader = false;
  }

  GetUserProfile() {
    //this.ShowLoader();
    this._http.get(this._appUrl.GetUserProfile)
      .subscribe(
        data => {

          // this.HideLoader();
          if (data.json().Result.Image != null && data.json().Result.Image != "" && data.json().Result.Image != undefined) {
            this.photo = 'data:image/jpeg;base64,' + data.json().Result.Image;
            this.pageSize = data.json().Result.PageSize;
            localStorage.setItem('PageSize', this.pageSize.toString());
          }
          else
            this.photo = "app/content/images/userIcon.jpg";

          if (data.json().Result.ProfileName != null && data.json().Result.ProfileName != "" && data.json().Result.ProfileName != undefined) {
            this.userName = data.json().Result.ProfileName;
          } else {
            var currentUser = JSON.parse(localStorage.getItem('currentUser'));
            if (currentUser != null && currentUser != "" && currentUser != undefined) {
              this.userName = currentUser.FullName || "";
            }
          }
        },
        error => {
          // this.HideLoader();
          this._toastrService.error(error.json().Result);
        }
      )
  }

  UpdateFormFillingPercentage(clientData: any) {
    let percentage = 0;
    this.ShowLoader();
    this._http.post(this._appUrl.UpdateFormFillingPercentage, clientData)
      .subscribe(
        data => {
          this.HideLoader();

          if (data.json().Result != null) {
            //  percentage = data.json().Result.FormFillingPercentage;
          }
        },
        error => {
          this.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
    return percentage;
  }

  AddUpdateComments(commentsData: any) {
    let percentage = 0;
    this.ShowLoader();
    this._http.post(this._appUrl.AddUpdateComments, commentsData)
      .subscribe(
        data => {
          this.HideLoader();
          if (data.json().Result != null) {
            this._toastrService.success(data.json().Result, '');
          }
        },
        error => {
          this.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  GetMenuItems() {
    //this.ShowLoader();
    this._http.get(this._appUrl.GetMenuItems)
      .subscribe(
        data => {
          //this.HideLoader();
          if (data.json().Result != null) {
            this.menuItems = data.json().Result;
            // Expand the menu item that matches the current route
            this.expandMenuForCurrentRoute();
          }
        },
        error => {
          // this.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  expandMenuForCurrentRoute() {
    // Clear all open menus first
    this.openMenuIndices.clear();

    if (!this.menuItems || this.menuItems.length === 0) {
      return;
    }

    const currentUrl = this.currentRoute || this._router.url;

    // Find the menu item that contains the current route
    for (let i = 0; i < this.menuItems.length; i++) {
      const menuItem = this.menuItems[i];
      
      // Check if this menu item or any of its submenus match the current route
      if (menuItem.NavUrl && currentUrl.includes('/' + menuItem.NavUrl)) {
        // Parent menu item matches
        this.openMenuIndices.add(i);
        return;
      }

      // Check if any submenu matches the current route
      if (menuItem.LstSubMenuItems && menuItem.LstSubMenuItems.length > 0) {
        const hasMatchingSubmenu = menuItem.LstSubMenuItems.some(subItem => 
          currentUrl.includes('/' + subItem.NavUrl)
        );
        
        if (hasMatchingSubmenu) {
          this.openMenuIndices.add(i);
          return;
        }
      }
    }
  }

  GetPagePrivlages(navUrl: string) {
    this._http.get(this._appUrl.GetRolePriv + navUrl)
      .subscribe(
        data => {
          if (data.json().Result != null) {

            this.canAdd = data.json().Result.CanAdd;
            this.canView = data.json().Result.CanView;
            this.canEdit = data.json().Result.CanEdit;
            this.canDelete = data.json().Result.CanDelete;
            this.canRevert = data.json().Result.CanRevert;
            this.isActive = data.json().Result.IsActive;
            if (!this.isActive) {
              this._router.navigate(['/dashboard']);
            }
          }
        },
        error => {
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  logout() {
    this.ShowLoader();
    this._amplifySrvc.ClearAll();
    localStorage.clear();
    if (localStorage.getItem('SessionId')) {
      // var sessionDetails = JSON.parse(localStorage.getItem('SessionId'));
      // let sessionId = sessionDetails.sessionId;
      this._http.get(this._appUrl.logout)
        .subscribe(
          customer => {
            this.HideLoader();
            this.isAuthorize = false;
          },// put the data returned from the server in our variable
          error => {
            this.HideLoader();
            // in case of failure show this message
          }
        )
      this.isAuthorize = false;
      this.photo = null;
      this.HideLoader();
    }

    //this._toastr.SucessMsg("Logout successfully");
    this.isAuthorize = false;
    this.isLoggedIn = false;
    localStorage.removeItem('currentUser');
    // localStorage.clear();
    this.userId = "";

    this._router.navigate(['/login']);
  }

  Download(imageData: string, fileName: string, fileExt: string) {

    var a = document.getElementById('btnDownload');
    a.setAttribute('href', imageData);
    a.setAttribute('target', '_blank')
    a.setAttribute('download', 'image.png')
    a.click();
  }

  DownloadFile(fileData) {
    // Create blob from base64 string
    const binaryString = window.atob(fileData.AnalysisReport);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    
    // Create blob and download URL
    const blob = new Blob([bytes], { type: fileData.ContentType });
    const url = window.URL.createObjectURL(blob);
    
    // Create download link and trigger download
    const link = document.createElement('a');
    link.href = url;
    link.download = fileData.FileName + '.' + fileData.ContentType;
    link.style.display = 'none';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Clean up the object URL
    window.URL.revokeObjectURL(url);
  }

  ClearAllAmplifyData() {
    this._amplifySrvc.ClearAll();
  }

  getCurrentUserData(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  }

  toggleSidebar() {
    if (this.isMobile && this.sidenav) {
      this.sidenav.toggle();
    } else {
      if (this.sidebarExpanded) {
        // Collapsing: close all expanded menus first
        this.openMenuIndices.clear();
        this.cdr.markForCheck();
        // Use setTimeout to ensure menu closes before sidebar collapses
        setTimeout(() => {
          this.sidebarExpanded = false;
          this.cdr.markForCheck();
        }, 50);
      } else {
        // Expanding: just expand the sidebar
        this.sidebarExpanded = true;
        this.expandMenuForCurrentRoute();
        this.cdr.markForCheck();
      }
    }
  }

  closeSidenavOnMobile() {
    if (this.isMobile && this.sidenav) {
      this.sidenav.close();
    }
  }

  onMenuItemClick(index: number, menuItem: any) {
    // If menu item has no submenus, navigate to its route
    if (!menuItem.LstSubMenuItems || menuItem.LstSubMenuItems.length === 0) {
      if (menuItem.NavUrl) {
        this._router.navigate(['/'+menuItem.NavUrl]);
        this.ClearAllAmplifyData();
        this.closeSidenavOnMobile();
      }
    } else {
      // If it has submenus and sidebar is expanded, toggle the submenu
      if (this.sidebarExpanded) {
        this.toggleSubmenu(new Event('click'), index);
        // Trigger change detection
        this.cdr.markForCheck();
      } else {
        // In collapsed mode, show flyout on click
        if (this.flyoutHoverTimer) {
          clearTimeout(this.flyoutHoverTimer);
        }
        if (this.flyoutLeaveTimer) {
          clearTimeout(this.flyoutLeaveTimer);
        }
        
        // Calculate flyout position
        this.calculateFlyoutPosition(index);
        
        // Show flyout
        this.hoveredMenuIndex = index;
        this.cdr.markForCheck();
      }
    }
  }

  onMenuItemHover(index: number, event?: MouseEvent) {
    if (!this.menuItems || this.menuItems.length === 0) {
      return;
    }
    
    const menuItem = this.menuItems[index];
    
    if (!this.sidebarExpanded && menuItem && menuItem.LstSubMenuItems && menuItem.LstSubMenuItems.length > 0) {
      // Clear any existing timers
      if (this.flyoutHoverTimer) {
        clearTimeout(this.flyoutHoverTimer);
      }
      if (this.flyoutLeaveTimer) {
        clearTimeout(this.flyoutLeaveTimer);
      }
      
      // Calculate flyout position based on hovered menu item
      this.calculateFlyoutPosition(index);
      
      // Show flyout immediately on hover
      this.hoveredMenuIndex = index;
      this.cdr.markForCheck();
    }
  }

  onMenuItemLeave(index: number) {
    if (!this.sidebarExpanded) {
      if (this.flyoutLeaveTimer) {
        clearTimeout(this.flyoutLeaveTimer);
      }
      
      // Delay hiding flyout to allow time to move to flyout menu
      this.flyoutLeaveTimer = setTimeout(() => {
        if (this.hoveredMenuIndex === index) {
          this.hoveredMenuIndex = -1;
          this.cdr.markForCheck();
        }
      }, 200);
    }
  }

  onFlyoutEnter(index: number) {
    if (this.flyoutLeaveTimer) {
      clearTimeout(this.flyoutLeaveTimer);
    }
    this.hoveredMenuIndex = index;
    this.cdr.markForCheck();
  }

  onFlyoutLeave() {
    if (this.flyoutLeaveTimer) {
      clearTimeout(this.flyoutLeaveTimer);
    }
    
    this.flyoutLeaveTimer = setTimeout(() => {
      this.hoveredMenuIndex = -1;
      this.cdr.markForCheck();
    }, 150);
  }

  onMenuKeyDown(event: KeyboardEvent, index: number) {
    const menuItem = this.menuItems[index];
    
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onMenuItemClick(index, menuItem);
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      const nextIndex = (index + 1) % this.menuItems.length;
      const nextElement = document.querySelectorAll('.menu-item-header')[nextIndex] as HTMLElement;
      if (nextElement) {
        nextElement.focus();
      }
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      const prevIndex = (index - 1 + this.menuItems.length) % this.menuItems.length;
      const prevElement = document.querySelectorAll('.menu-item-header')[prevIndex] as HTMLElement;
      if (prevElement) {
        prevElement.focus();
      }
    }
  }

  onSubmenuKeyDown(event: KeyboardEvent, subMenuItem: any) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.ClearAllAmplifyData();
      this.closeSidenavOnMobile();
      this._router.navigate(['/'+subMenuItem.NavUrl]);
    }
  }

  toggleSubmenu(event: any, index: number) {
    event.stopPropagation();
    // Check if the clicked menu is already open
    if (this.openMenuIndices.has(index)) {
      // If it's open, close it
      this.openMenuIndices.delete(index);
    } else {
      // If it's closed, close all other menus and open this one
      this.openMenuIndices.clear();
      this.openMenuIndices.add(index);
    }
  }


  isMenuItemActive(menuItem: any): boolean {
    if (!menuItem.LstSubMenuItems || menuItem.LstSubMenuItems.length === 0) {
      return this.isCurrentRoute(menuItem.NavUrl);
    }
    // Check if any submenu item is active based on URL pattern matching
    return menuItem.LstSubMenuItems.some(subItem => this.isCurrentRoute(subItem.NavUrl));
  }

  isSubMenuItemActive(subMenuItem: any): boolean {
    return this.isCurrentRoute(subMenuItem.NavUrl);
  }

  isSubMenuItemActiveByUrl(subMenuItem: any): boolean {
    const navUrl = subMenuItem.NavUrl;
    const currentUrl = this.currentRoute || this._router.url;
    
    // Exact match
    if (currentUrl.includes('/' + navUrl)) {
      return true;
    }
    
    // Pattern match for related URLs
    // e.g., "addeditlab" matches "lablist", "addedituser" matches "userlist", etc.
    let currentBasePath = currentUrl.substring(1).split('/')[0]; // Get first segment
    
    // Remove 'addedit' prefix if present
    let baseRoute = currentBasePath.replace(/^addedit/, '').toLowerCase();
    let submenuRoute = navUrl.toLowerCase();
    
    // Check if they match (accounting for singular/plural variations)
    if (baseRoute && submenuRoute && baseRoute === submenuRoute) {
      return true;
    }
    
    // Check if submenu route + "list" matches current route
    if ((submenuRoute + 'list') === currentBasePath.toLowerCase()) {
      return true;
    }
    
    return false;
  }

  isCurrentRoute(route: string): boolean {
    const currentUrl = this.currentRoute || this._router.url;
    
    // Remove leading slash from current URL for comparison
    let urlToMatch = currentUrl;
    if (urlToMatch.startsWith('/')) {
      urlToMatch = urlToMatch.substring(1);
    }
    
    // Remove leading slash from route for comparison
    let routeToMatch = route;
    if (routeToMatch.startsWith('/')) {
      routeToMatch = routeToMatch.substring(1);
    }
    
    // 1. Check exact match
    if (urlToMatch === routeToMatch) {
      return true;
    }
    
    // 2. Check if current URL path matches the route using route-to-menu mapping
    const mappedRoute = this.getMappedParentRoute(urlToMatch);
    if (mappedRoute && mappedRoute === routeToMatch) {
      return true;
    }
    
    // 3. For routes with parameters, extract the base route and compare
    const urlSegments = urlToMatch.split('/');
    const routeSegments = routeToMatch.split('/');
    
    // If the route has segments, check for partial match with parameters
    if (urlSegments.length >= 1 && routeSegments.length >= 1) {
      // Match first segment and any exact parameter placeholders
      let isMatch = true;
      const minLength = Math.min(urlSegments.length, routeSegments.length);
      
      for (let i = 0; i < minLength; i++) {
        const urlSeg = urlSegments[i];
        const routeSeg = routeSegments[i];
        
        // If route segment has parameter placeholder (e.g., :id), accept any value
        if (routeSeg.startsWith(':')) {
          continue;
        }
        
        // If segments don't match, no match
        if (urlSeg !== routeSeg) {
          isMatch = false;
          break;
        }
      }
      
      if (isMatch && urlSegments.length >= routeSegments.length) {
        return true;
      }
    }
    
    return false;
  }


  private getMappedParentRoute(currentPath: string): string | null {
    // Remove parameters from current path for matching
    const pathWithoutParams = currentPath.split('/')[0];
    
    // Try exact match in mapping
    if (ROUTE_TO_MENU_MAPPING[currentPath]) {
      return ROUTE_TO_MENU_MAPPING[currentPath];
    }
    
    // Try matching with parameter placeholder
    for (const mappedRoute of Object.keys(ROUTE_TO_MENU_MAPPING)) {
      if (this.routeWithParamsMatches(currentPath, mappedRoute)) {
        return ROUTE_TO_MENU_MAPPING[mappedRoute];
      }
    }
    
    return null;
  }

  /**
   * Check if current path matches a route pattern with parameters
   * e.g., currentPath="/addedituser/123" matches pattern="addedituser/:id"
   */
  private routeWithParamsMatches(currentPath: string, routePattern: string): boolean {
    const currentSegments = currentPath.split('/').filter(s => s.length > 0);
    const patternSegments = routePattern.split('/').filter(s => s.length > 0);
    
    if (currentSegments.length !== patternSegments.length) {
      return false;
    }
    
    for (let i = 0; i < patternSegments.length; i++) {
      const pattern = patternSegments[i];
      const current = currentSegments[i];
      
      // If pattern is a parameter placeholder, it matches any value
      if (pattern.startsWith(':')) {
        continue;
      }
      
      // Otherwise, segments must match exactly
      if (pattern !== current) {
        return false;
      }
    }
    
    return true;
  }

  isSubmenuOpen(index: number): boolean {
    return this.openMenuIndices.has(index);
  }

  calculateFlyoutPosition(index: number): void {
    // Use setTimeout to ensure DOM is updated
    setTimeout(() => {
      const menuItemElements = document.querySelectorAll('.menu-item-wrapper');
      
      if (!menuItemElements || menuItemElements.length === 0 || !menuItemElements[index]) {
        return;
      }
      
      const element = menuItemElements[index] as HTMLElement;
      const rect = element.getBoundingClientRect();
      
      // Get the sidebar element to account for its position
      const sidebar = document.querySelector('.sidenav') as HTMLElement;
      const sidebarRect = sidebar ? sidebar.getBoundingClientRect() : null;
      
      // Flyout should appear to the right of the sidebar
      const sidebarRight = sidebarRect ? sidebarRect.right : 70;
      const leftPosition = sidebarRight;
      
      // Calculate approximate flyout height based on number of submenus
      const menuItem = this.menuItems[index];
      if (!menuItem || !menuItem.LstSubMenuItems) {
        return;
      }
      
      const itemCount = menuItem.LstSubMenuItems.length;
      const flyoutItemHeight = 40; // approximate height per item
      const flyoutPadding = 20; // top/bottom padding
      const calculatedHeight = (itemCount * flyoutItemHeight) + flyoutPadding;
      const maxFlyoutHeight = 500; // hard max
      const flyoutHeight = Math.min(calculatedHeight, maxFlyoutHeight);
      
      const viewportHeight = window.innerHeight;
      const topMargin = 50; // Start from 50px below top
      
      // Default: align top of flyout with top of menu item
      let topPosition = rect.top;
      
      // Ensure minimum top margin of 50px
      if (topPosition < topMargin) {
        topPosition = topMargin;
      }
      
      // Check if flyout would exceed viewport height when positioned at rect.top
      if (topPosition + flyoutHeight > viewportHeight) {
        // Not enough space below, move flyout up
        topPosition = Math.max(topMargin, viewportHeight - flyoutHeight - 10);
      }
      
      this.flyoutPosition = {
        top: topPosition + 'px',
        left: leftPosition + 'px'
      };
      
      this.cdr.markForCheck();
    }, 0);
  }

  getFlyoutPosition(index: number): any {
    // Return the calculated position for ngStyle
    return {
      'top': this.flyoutPosition.top,
      'left': this.flyoutPosition.left,
      'position': 'fixed',
      'pointer-events': 'auto'
    };
  }
}



